import InputsPage from './InputsPage';

export default InputsPage;
